import {InvDetailType} from "../interface";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    invDetail: InvDetailType
}

export default function Tab2({invDetail}: PropsType) {
    return <div className="content_wrap">
        <h5 className="subheading mt-0">제품 정보</h5>
        
        <table className="table table-bordered my_table table_detail">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>품목명</th>
                {/* 내부수정: 마진 변경 p-4px -> ps-2 */}
                <td style={{width: "33.32%"}} className="ps-2">
                    {invDetail.newTxtNmItem}
                </td>
                <th style={{width: "16.66%"}}>품목코드</th>
                <td className="ps-2">
                    {invDetail.newTxtCdItem}
                </td>
            </tr>
            <tr>
                <th>벤더</th>
                <td className="ps-2">
                    {invDetail.vendor}
                </td>
                <th>대분류</th>
                <td className="ps-2">
                    {invDetail.majorCategory}
                </td>
            </tr>
            <tr>
                <th>카테고리</th>
                <td className="ps-2">
                    {invDetail.category}
                </td>
                <th>중분류</th>
                <td className="ps-2">
                    {invDetail.subCategory}
                </td>
            </tr>
            <tr>
                <th>규격</th>
                <td className="ps-2">
                    {invDetail.newTxtStndItem}
                </td>
                <th>사업부별 제품군</th>
                <td className="ps-2">
                    {invDetail.productRange}
                </td>
            </tr>
            </tbody>
        </table>

        <h5 className="subheading mt-20px">재고 정보</h5>
        <table className="table table-bordered my_table table_detail">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>단위</th>
                <td style={{width: "33.32%"}} className="ps-2">
                    {invDetail.inventoryUnit}
                </td>
                <th style={{width: "16.66%"}}>안전 재고</th>
                <td className="ps-2">
                    {invDetail.safetyAmount}
                </td>
            </tr>
            <tr>
                <th>구매가</th>
                <td className="ps-2">
                    <DisplayNumber value={invDetail.originalPrice}/>
                </td>
                <th>판매가</th>
                <td className="ps-2">
                    <DisplayNumber value={invDetail.sellingPrice}/>
                </td>
            </tr>
            <tr>
                <th>바코드</th>
                <td colSpan={3} className="ps-2">
                    {invDetail.barcode}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}